import type { CartItem } from 'models/purchaseFlowRevamp'

/** One cart entry: an ordinary line, or every line of one pack purchase shown together. */
export type CartEntry<Row extends { id: string }> =
  | { kind: 'line'; row: Row }
  | { kind: 'pack'; selectionId: string; packProductCode: string; rows: Row[] }

/** Groups the rows of each pack purchase where its first line sits; other lines keep their order. */
export function groupRowsByPack<Row extends { id: string }>(rows: Row[], items: CartItem[]): CartEntry<Row>[] {
  const packOf = new Map(items.filter((item) => item.pack).map((item) => [item.id, item.pack!]))
  const entries: CartEntry<Row>[] = []
  const packEntries = new Map<string, Extract<CartEntry<Row>, { kind: 'pack' }>>()
  for (const row of rows) {
    const pack = packOf.get(row.id)
    if (!pack) {
      entries.push({ kind: 'line', row })
      continue
    }
    const existing = packEntries.get(pack.selectionId)
    if (existing) {
      existing.rows.push(row)
      continue
    }
    const entry = { kind: 'pack' as const, selectionId: pack.selectionId, packProductCode: pack.productCode, rows: [row] }
    packEntries.set(pack.selectionId, entry)
    entries.push(entry)
  }
  return entries
}
